export default {
  small: 4, //  Small components - i.e. Buttons, Chips, FormFields
  medium: 4, // Medium components - i.e. Cards, Modals
  large: 4, // Large components - i.e. SideMenu
};
